import React from 'react';

/**
 * Price comparison table: Your Service vs Authorized vs Local.
 *
 * Props:
 *   columns - array of { label, icon, isRnr: bool }
 *     e.g. [
 *       { label: 'Vehicle Type' },
 *       { label: 'Authorized Center', icon: '🏢' },
 *       { label: 'Local Mechanic', icon: '🔧' },
 *       { label: 'Ride N Repair', icon: '⭐', isRnr: true },
 *     ]
 *   rows - array of {
 *     cells: [
 *       { text, bold },           // Vehicle type
 *       { text, strikethrough },   // Authorized
 *       { text, faded },           // Local
 *       { text, saveBadge, isRnr } // RNR
 *     ]
 *   }
 *   note - footnote text
 *   ctaHref - CTA link
 *   ctaLabel - CTA text
 */
const ComparisonTable = ({
  columns = [],
  rows = [],
  note,
  ctaHref,
  ctaLabel = 'Book at Best Price',
}) => {
  if (rows.length === 0) return null;

  return (
    <>
      <div className="rr-comparison-table__wrap">
        <table className="rr-comparison-table__table">
          <thead>
            <tr>
              {columns.map((col, i) => (
                <th
                  key={i}
                  className={`rr-comparison-table__th${col.isRnr ? ' rr-comparison-table__th--rnr' : ''}`}
                >
                  {col.icon ? (
                    <div className="rr-comparison-table__th-inner">
                      <span className="rr-comparison-table__th-icon">{col.icon}</span>
                      {col.label}
                    </div>
                  ) : (
                    col.label
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, ri) => (
              <tr key={ri} className={ri % 2 !== 0 ? 'rr-comparison-table__row--alt' : ''}>
                {row.cells.map((cell, ci) => {
                  let cellClass = 'rr-comparison-table__td';
                  if (cell.strikethrough) cellClass += ' rr-comparison-table__td--strikethrough';
                  if (cell.faded) cellClass += ' rr-comparison-table__td--faded';
                  if (cell.isRnr) cellClass += ' rr-comparison-table__td--rnr';

                  return (
                    <td key={ci} className={cellClass}>
                      {cell.isRnr ? (
                        <>
                          <div className="rr-comparison-table__rnr-price">{cell.text}</div>
                          {cell.saveBadge && (
                            <div className="rr-comparison-table__save-badge">{cell.saveBadge}</div>
                          )}
                        </>
                      ) : cell.bold ? (
                        <strong>{cell.text}</strong>
                      ) : (
                        cell.text
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {note && <div className="rr-comparison-table__note">{note}</div>}
      {ctaHref && (
        <div className="rr-comparison-table__cta">
          <a href={ctaHref} className="rr-cta-primary">{ctaLabel}</a>
        </div>
      )}
    </>
  );
};

export default ComparisonTable;
